import React from 'react';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import Loader from "../Components/Loader";
import useTheme from './useTheme';

function ThemeConfig({ children }) {
    
 const {
    loading,
    theme
 } = useTheme()
    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <Loader open={loading} />
                {children}
            </ThemeProvider>
        </StyledEngineProvider>

    )
}

export default ThemeConfig;